import { cn } from "@/lib/utils";
import { Link, useLocation } from "@tanstack/react-router";
import {
	CommentIcon,
	ContactIcon,
	CreationIcon,
	DepositIcon,
	GemIcon,
	InviteIcon,
	LogoutIcon,
	UserIcon,
} from "~/components/icons";

import { authStore } from "@/lib/auth/store";
import { m } from "@/paraglide/messages";
import { localizeHref } from "@/paraglide/runtime";
import { useStore } from "@tanstack/react-store";
import { useState } from "react";
import { CloseIcon } from "~/components/icons";
import {
	AlertDialog,
	AlertDialogAction,
	AlertDialogCancel,
	AlertDialogContent,
	AlertDialogFooter,
	AlertDialogHeader,
	AlertDialogTitle,
} from "~/components/ui/alert-dialog";

export const navs = [
	{
		label: m.profile_account(),
		path: "account",
		icon: <UserIcon className="[&>path]:stroke-t2 [&>g>path]:stroke-t2" />,
	},
	{
		label: m.profile_deposit_record(),
		path: "deposit",
		icon: <DepositIcon className="[&>path]:stroke-t2 [&>g>path]:stroke-t2" />,
	},
	{
		label: m.profile_gem_record(),
		path: "gem",
		icon: <GemIcon className="[&>path]:stroke-t2 [&>g>path]:stroke-t2" />,
	},
	{
		label: m.profile_creation(),
		path: "creation",
		icon: <CreationIcon className="[&>path]:stroke-t2 [&>g>path]:stroke-t2" />,
	},
	{
		label: m.profile_comment(),
		path: "comment",
		icon: <CommentIcon className="[&>path]:stroke-t2 [&>g>path]:stroke-t2" />,
	},
	{
		label: m.profile_invite(),
		path: "invite",
		icon: <InviteIcon className="[&>path]:stroke-t2 [&>g>path]:stroke-t2" />,
	},
	{
		label: m.profile_contact(),
		path: "contact",
		icon: <ContactIcon className="[&>path]:fill-t2 " />,
	},
] as const;

export function ProfileNav({
	className,
}: {
	className?: string;
}) {
	const location = useLocation();
	const [showAlert, setShowAlert] = useState(false);

	// 退出登录
	const { doLogout } = useStore(authStore);
	const handleLogout = () => {
		doLogout();
		setShowAlert(false);
	};
	return (
		<div
			className={cn(
				"w-full md:w-[205px] flex-shrink-0 bg-card rounded-[20px] md:shadow-card overflow-hidden",
				className,
			)}
		>
			<nav className="flex flex-col">
				{navs.map((nav) => (
					<Link
						key={nav.path}
						to={localizeHref(`/profile/${nav.path}`)}
						className={`flex items-center h-[50px] gap-2 p-4 text-t2 border-b border-b-line1 hover:opacity-80 ${
							location.pathname === localizeHref(`/profile/${nav.path}`)
								? "bg-c1 text-t1"
								: "text-t2"
						}`}
					>
						{nav.icon}
						{nav.label}
					</Link>
				))}
				<button
					type="button"
					onClick={() => setShowAlert(true)}
					className="flex items-center cursor-pointer h-[50px] gap-2 p-4 text-t2 border-b border-b-line1 hover:opacity-80"
				>
					<LogoutIcon className="[&>path]:stroke-t2" />
					<m.logout />
				</button>
			</nav>
			<AlertDialog open={showAlert} onOpenChange={setShowAlert}>
				<AlertDialogContent>
					<AlertDialogHeader>
						<div
							className="flex justify-end cursor-pointer"
							onClick={() => setShowAlert(false)}
						>
							<CloseIcon />
						</div>

						<div className="flex justify-center mb-3">
							<img
								src="/assets/images/profile/logout_pic.png"
								className="w-[120px] h-[120px] object-fill"
								alt="logout"
							/>
						</div>
						<AlertDialogTitle className="text-center text-t1 text-base font-normal">
							<m.logout_confirm />
						</AlertDialogTitle>
					</AlertDialogHeader>
					<AlertDialogFooter>
						<AlertDialogCancel className="flex-1 bg-bg2 border-0 rounded-full text-sm text-t1 h-10 hover:!bg-bg5 hover:text-w1 cursor-pointer">
							<m.common_cancel />
						</AlertDialogCancel>
						<AlertDialogAction
							className="flex-1 bg-c1 border-0 rounded-full text-sm text-t1 h-10 hover:bg-main1 hover:text-w1 cursor-pointer"
							onClick={handleLogout}
						>
							<m.common_confirm />
						</AlertDialogAction>
					</AlertDialogFooter>
				</AlertDialogContent>
			</AlertDialog>
		</div>
	);
}
